import styled, { keyframes } from "styled-components";

import { FaCheck } from "react-icons/fa";
import Select from "../../../components/Select";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Content = styled.div`
  width: 80%;
  height: fit-content;
  margin: 40px 10px;
  z-index: 1;

  padding: 30px;
  border-radius: 10px;
  background-color: #eee;
  box-shadow: 2px 2px 5px;

  overflow: hidden;

  animation: ${fadeIn} 0.4s;

  > header {
    margin-bottom: 10px;

    > h2 {
      text-align: center;
      font-size: 25px;
      margin-bottom: 10px;

      color: var(--black);
    }

    > p {
      text-align: center;
      font-size: 0.8rem;
      margin-bottom: 5px;

      color: var(--black);
    }

    > span {
      display: flex;
      align-items: center;

      cursor: pointer;
      :hover {
        opacity: 0.8;
      }
      :active {
        opacity: 0.4;
      }

      > p {
        margin-left: 5px;
        font-size: 16px;

        font-weight: bold;
      }
    }

    > h1 {
      font-size: 25px;
      margin-top: 10px;
    }
  }

  @media (max-width: 425px) {
    width: 90%;
    margin: 40px 10px;
    padding-bottom: 100px;
  }
`;

export const ContentEnviando = styled(Content)`
  background-color: ${(props) => (props.enviando ? "#0B0434" : "#EEE")};

  > header h2 {
    color: ${(props) => (props.enviando ? "#EEE" : "var(--black)")};
  }

  transition: 0.2s;
`;

export const FormFiltro = styled.form`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 10px;

  > h1 {
    font-size: 25px;
    margin: 10px 0px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const SelectCurso = styled(Select)`
  grid-column: 1/3;
`;

export const SelectArea = styled(Select)`
  grid-column: 1/3;
`;

export const Linha = styled.div`
  grid-column: 1/3;

  > h1 {
    font-size: 25px;
    margin: 10px 0px;
  }

  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const LinhaTags = styled(Linha)`
  flex-wrap: wrap;
`;

export const StyledTag = styled.article`
  padding: 5px 10px;
  display: flex;
  align-items: center;

  animation: ${fadeIn} 0.2s;

  border-radius: 15px;
  background-color: var(--primary);
  color: var(--white);

  margin: 0px 0px 5px 5px;

  > span {
    margin-left: 10px;
    cursor: pointer;
    font-size: 20px;

    :hover {
      opacity: 0.8;
    }
    :active {
      opacity: 0.4;
    }
  }
`;

export const Button = styled.button`
  margin: 0 auto;
  width: 100%;
  background-color: ${(props) => "var(--" + props.color + ")"};

  ${(props) =>
    props.direction === "left"
      ? "border-radius: 40px 0px 0px 40px"
      : "border-radius: 0 40px 40px 0"};
  position: relative;
`;

export const ButtonLink = styled.button`
  width: unset;
  padding: unset;
  text-align: left;

  color: var(--black);
  background-color: unset;
  border: unset;

  :active {
    border: none;
  }
`;

export const ContainerDone = styled.div`
  animation: ${fadeIn} 0.3s;

  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 32px;
  text-align: center;
`;

const done = keyframes`
  from {
    size: 50;
    transform: rotate(0deg);
  }

  to {
    size: 200;
    transform: rotate(360deg);
  }
`;

export const AnimatedDone = styled(FaCheck)`
  size: 200;
  color: var(--alertSucesso);

  animation: ${done} 0.4s ease-out;
`;

export const ContainerAno = styled.div`
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > span {
    white-space: nowrap;
  }

  > input {
    margin: 0px 10px 0px 10px;

    width: 33%;
  }
  margin-bottom: 10px;
`;

export const Quantidade = styled.div`
  animation: ${fadeIn} 0.3s;

  position: fixed;
  margin: 10px;
  top: 50px;
  right: 0;
  z-index: 9;

  background-color: var(--white);
  box-shadow: 0px 0px 10px;
  padding: 10px;
  border-radius: 10px;
  color: var(--black);

  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 32px;
  text-align: center;

  > p {
    margin: 10px;
    font-size: 16px;
    font-weight: bold;

    animation: ${fadeIn} 0.2s;

    > em {
      font-style: unset;
      font-weight: bold;
      font-size: 30px;
      color: var(--green);
    }
  }
  @media (max-width: 1200px) {
    width: calc(80%);
    top: auto;
    bottom: 30px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    z-index: 9;
  }

  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    margin: 20px 0px;
    top: 0;
    right: 0;
  }
`;

export const Dicas = styled.ul`
  line-height: 2;
  text-align: center;

  > li {
    list-style-type: none;
  }
`;
